
export default [
  {
    name: `instruction_1`,
    title: `滑動螢幕探索純淨之巔`,
  },
];
